import styleInject from '../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".vai-form-error {\n  --vai-color-fg: var(--vai-color-red);\n  color: var(--vai-color-fg);\n  font: var(--vai-text-body);\n}\n[data-vai-theme-mode=dark] .vai-form-error {\n  --vai-color-fg: var(--vai-color-washed-red);\n}\n.vai-form-error--message {\n  margin-right: 4px;\n}";
styleInject(css_248z,{"insertAt":"top"});

export { css_248z as default };
